class Smartcrop {
    constructor(image) {
        this.image = image;

        this.init();
    }

    init() {
        this.setProperties();
    }

    setProperties() {
        this.image.style.setProperty(
            "--image-init-height",
            this.image.offsetHeight + "px",
        );
        this.image.style.setProperty(
            "--image-init-width",
            this.image.offsetWidth + "px",
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const images = document.querySelectorAll("[data-smartcrop]");
    images.forEach((image) => {
        new Smartcrop(image);
    });
});
